export default __webpack_public_path__ + "static/media/Gate-Button.f387d1a6.png";